module.exports = __webpack_public_path__ + "static/media/Soilcheck_color.8d61a726.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/central_fert/Soilcheck_color.png
// module id = 2489
// module chunks = 3